import { render, staticRenderFns } from "./MainBread.vue?vue&type=template&id=5d7b26e4&scoped=true&"
import script from "./MainBread.vue?vue&type=script&lang=ts&"
export * from "./MainBread.vue?vue&type=script&lang=ts&"
import style0 from "./MainBread.vue?vue&type=style&index=0&id=5d7b26e4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7b26e4",
  null
  
)

export default component.exports